// import * as firebase from 'firebase'
import authApi from '@/api/auth'
import account from '@/api/account'
import router from '@/router'

export default {
  state: {
    user: null
  },
  mutations: {
    setUser (state, payload) {
      console.log('commit set user')
      console.log(payload)
      state.user = payload
    }
  },
  actions: {
    signup ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      authApi.signup(payload.firstName, payload.lastName, payload.email, payload.password, payload.organisation, payload.agreed)
        .then(resp => {
          console.log('done!')
          console.log(resp)
          commit('setLoading', false)
          // Uncomment to login the user automatically after signup
          // Currently login is disabled until an admin has reviewed and approved the registration
          /*
            const newUser = {
            id: resp.data.account.id,
            firstName: resp.data.user.firstName,
            lastName: resp.data.user.lastName,
            role: resp.data.user.role,
            token: resp.data.token,
            fbKeys: {}
          }
          commit('setUser', newUser)
          router.push('/')
          */
          router.push('/registration/complete')
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    signin ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      authApi.login(payload.email, payload.password, '')
        .then(resp => {
          console.log('done!')
          commit('setLoading', false)
          const newUser = {
            id: resp.data.account.id,
            firstName: resp.data.user.firstName,
            lastName: resp.data.user.lastName,
            role: resp.data.user.role,
            token: resp.data.token,
            organisation: resp.data.organisation.name,
            organisationId: resp.data.organisation.id,
            fbKeys: {}
          }
          commit('setUser', newUser)
          // if (router.params.nextUrl != null) {
          //   router.push(router.params.nextUrl)
          // } else {
          // router.push('/')
          // }
          router.push('/')
        })
        .catch(error => {
          commit('setLoading', false)
          // If error is for password reset
          if (error.code === 18) {
            router.push('/reset-password-notification?email=' + payload.email)
          } else {
            commit('setError', error)
          }
          console.log(error)
        })
    },
    loadUserData ({ commit }, payload) {
      console.log('store/user :: loadUserData ')
      commit('setLoading', true)
      account.loadAccount('me')
        .then(resp => {
          console.log(resp)
          commit('setLoading', false)
          const userData = {
            id: resp.data.account.id,
            firstName: resp.data.account.firstName,
            lastName: resp.data.account.lastName,
            email: resp.data.account.email,
            role: resp.data.account.role,
            organisation: resp.data.organisation.name,
            organisationId: resp.data.organisation.id
          }
          commit('setUser', userData)
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    autoSignIn ({ commit }, payload) {
      commit('setUser', {
        token: payload.token,
        role: payload.role
      })
      // router.push('/')
    },
    logout ({ commit }) {
      window.localStorage.removeItem('jwt')
      commit('setUser', null)
      router.push('/login')
    },
    resetPassword ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      return new Promise((resolve, reject) => {
        authApi.resetPassword(payload.email)
          .then(resp => {
            commit('setLoading', false)
            resolve()
          })
          .catch(error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
            reject(error)
          })
      })
    },
    validateResetPasswordHash ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      return new Promise((resolve, reject) => {
        authApi.validateResetPasswordHash(payload.hash)
          .then(resp => {
            commit('setLoading', false)
            resolve()
          })
          .catch(error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
            reject(error)
          })
      })
    },
    setNewPasswordHash ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      return new Promise((resolve, reject) => {
        authApi.setNewPassword(payload.hash, payload.password)
          .then(resp => {
            commit('setLoading', false)
            resolve()
          })
          .catch(error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
            reject(error)
          })
      })
    },
    confirmEmail ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      return new Promise((resolve, reject) => {
        authApi.confirmEmail(payload.hash)
          .then(resp => {
            commit('setLoading', false)
            resolve()
          })
          .catch(error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
            reject(error)
          })
      })
    },
    validateInvitationHash ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      return new Promise((resolve, reject) => {
        authApi.validateInvitationHash(payload.hash)
          .then(resp => {
            commit('setLoading', false)
            resolve(resp)
          })
          .catch(error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
            reject(error)
          })
      })
    },
    acceptInvitation ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      return new Promise((resolve, reject) => {
        authApi.acceptInvitation(payload.hash, payload.password)
          .then(resp => {
            commit('setLoading', false)
            resolve(resp)
          })
          .catch(error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
            reject(error)
          })
      })
    },
    clearError ({ commit }) {
      commit('clearError')
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    isAdminUser (state) {
      return state.user.role === 'admin' || state.user.role === 'dev'
    },
    isManagerUser (state) {
      return state.user.role === 'manager'
    }
  }
}
